import Button from '@mui/material/Button';
import { useFormContext } from 'react-hook-form';

import { useCloverPaymentForm } from 'payments/providers/CloverPaymentFormProvider';
import { useLocation } from 'reservations/account/providers/ConfigProvider';
import { useVisitId } from 'reservations/base/hooks/useQueryParams';
import { useErrorSnackbar } from 'reservations/base/hooks/useSnackbar';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { useCustomRouter } from 'reservations/base/providers/RouterProvider';
import { useBookingId } from 'reservations/booking/providers/BookingProvider';
import { useIsSubjectToCancellationFee } from 'reservations/feePolicy/hooks';
import { useUpdateBookingMutationV2 } from 'reservations/form/queries/useUpdateBookingMutationV2';

export const UpdateReservationButtonV2 = () => {
  const { handleIsLoading, handleHasLoaded } = useLoadingSpinner();
  const { handleSubmit: handleSubmitBookingForm } = useFormContext();
  const handlePaymentForm = useCloverPaymentForm()?.handlePaymentForm;
  const { handleNavigation } = useCustomRouter();
  const { slug } = useLocation();
  const bookingId = useBookingId();
  const visitId = useVisitId();

  const updateBookingMutationV2 = useUpdateBookingMutationV2({
    handleSuccess: () => {
      handleNavigation(
        `/locations/${slug}/booking/${bookingId}?visitId=${visitId}`
      );
    }
  });
  const isSubjectToCancellationFee = useIsSubjectToCancellationFee();
  const enqueueErrorSnackbar = useErrorSnackbar();

  // // istanbul ignore next
  const onSubmit = (data: Record<string, any>) => {
    updateBookingMutationV2.mutate(data);
  };

  const handleSubmit = async () => {
    if (isSubjectToCancellationFee && handlePaymentForm) {
      const paymentSuccess = await handlePaymentForm();
      if (!paymentSuccess) {
        enqueueErrorSnackbar(
          'PAYMENT_FAILED',
          'Unable to process your payment. Please try again.'
        );
        return;
      }
    }

    handleIsLoading('Updating your reservation...');

    const onValidation = (errors: any) => {
      if (errors?.token) {
        enqueueErrorSnackbar(
          'TOKEN_REQUIRED',
          'Credit card required. Please add your payment information to complete this reservation.'
        );
      }
      handleHasLoaded();
    };

    return handleSubmitBookingForm(onSubmit, onValidation)();
  };

  return (
    <Button
      data-testid="update-reservation-button-v2"
      onClick={handleSubmit}
      size="fullWidth"
    >
      Update Reservation
    </Button>
  );
};
